function getCharacterWidth(char: string): number {
  // 영어 대문자, 소문자, 숫자
  if (/^[a-zA-Z0-9]$/.test(char)) {
    return 8; // 영어 및 숫자 8px로 가정
  }
  // 한글
  else if (/^[가-힣]$/.test(char)) {
    return 10; // 한글 10px로 가정
  }
  // 공백
  else if (char === ' ') {
    return 4; // 공백 4px로 가정
  }
  // 개행 문자
  else if (char === '\n') {
    return 0; // 개행 문자는 너비에 영향을 주지 않음
  }
  // 그 외의 문자 (특수 문자)
  else {
    return 8; // 기타 문자 8px로 가정
  }
}

function getTextWidth(text: string): number {
  let width = 0;
  for (const char of text) {
    width += getCharacterWidth(char); // 해당 문자의 너비를 더함
  }
  return width; // 총 길이 반환
}

export function calcLineBreaks(text: string, maxWidth: number): number {
  const lines: string[] = [];
  let line = '';

  const words = text.split(''); // 문자를 기준으로 분할

  for (const char of words) {
    // 개행 문자가 있으면 현재 라인을 저장하고 새 줄 시작
    if (char === '\n') {
      if (line) {
        lines.push(line); // 현재 라인 추가
        line = ''; // 새 라인 초기화
      }
      continue; // 다음 문자로 진행
    }

    const testLine = line + char; // 현재 라인에 문자 추가
    const testWidth = getTextWidth(testLine); // 현재 라인의 너비 측정

    // 현재 라인의 너비가 최대 너비를 초과하면 줄바꿈
    if (testWidth > maxWidth && line) {
      lines.push(line); // 너비 초과 시 현재 라인을 저장
      line = char; // 새 라인에 현재 문자 추가
    } else {
      line = testLine; // 너비 내에선 계속해서 문자 추가
    }
  }
  // 남은 라인 추가
  if (line) {
    lines.push(line);
  }

  return lines.length;
}
